import { render, staticRenderFns } from "./RedactorSpotBriefPanel.vue?vue&type=template&id=73c9a6d6&"
import script from "./RedactorSpotBriefPanel.vue?vue&type=script&lang=js&"
export * from "./RedactorSpotBriefPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports